var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcModulo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1.75V40.25H36.75V11.7408L26.7575 1.75H5.25ZM35 38.5H7V3.5H24.5V14H35V38.5ZM35 12.25H26.25V3.5H26.6L35 11.9V12.25ZM10.5 35H31.5V17.5H10.5V35ZM17.5 33.25V29.75H22.75V33.25H17.5ZM17.5 28V24.5H22.75V28H17.5ZM29.75 33.25H24.5V29.75H29.75V33.25ZM29.75 28H24.5V24.5H29.75V28ZM29.75 19.25V22.75H24.5V19.25H29.75ZM22.75 19.25V22.75H17.5V19.25H22.75ZM12.25 19.25H15.75V22.75H12.25V19.25ZM12.25 24.5H15.75V28H12.25V24.5ZM12.25 29.75H15.75V33.25H12.25V29.75ZM22.75 8.75H10.5V7H22.75V8.75ZM22.75 12.25H10.5V10.5H22.75V12.25Z",
    fill: "#E44863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModulo);
export default __webpack_public_path__ + "static/media/ic_modulo.a535d01a115403a55616558bc2eeb0bc.svg";
export { ForwardRef as ReactComponent };